export default "__VITE_PUBLIC_ASSET__7e4d0137__"